const OnlinePaymentSoftwareHeroStore = {
    heroImage: 'marketing_site/online-payments/Hero_desktop.png',
    heroImageMweb: 'marketing_site/online-payments/hero-mweb.png'
};

export default OnlinePaymentSoftwareHeroStore;
